import moment from 'moment';
import { getMODToken } from '../api';
import { didSessionUpdate, getStorage, setStorage } from './session';

let refetchInterval;

export const pingMod = () => {
  getMODToken().then((isRefreshed) => {
    if (isRefreshed) {
      setStorage({ modExpiry: moment().add(refetchInterval, 'ms') });
      setTimeout(pingMod, refetchInterval);
    }
    else pingMod();
  })
  .catch(pingMod);
};

export const initializeMarkitSession = (_refetchInterval: number) => {
  refetchInterval = _refetchInterval;

  const expiry = getStorage().modExpiry;
  const now = moment();
  if (!expiry || now > expiry || didSessionUpdate) pingMod();
  else setTimeout(pingMod, expiry.diff(now));
};
